import { Injectable } from "@angular/core";

import {
    canSubmitWhileImpersonated,
    isImpersonated,
} from "src/app/_app-core/impersonation-upload";

/**
 * GPXUSAP-1860 — thin Angular wrapper around `_app-core/impersonation-upload.ts`
 * (the pure, unit-tested core). Keep this class free of logic beyond reading
 * localStorage/window and delegating; add new rules to the pure module and
 * its vitest spec instead.
 *
 * uiConfig flag: this vendor SPA does not currently retain the `uiConfig`
 * block the login/impersonate responses may carry (see
 * `sign-in.component.ts` / `impersonate.component.ts` — only
 * `logisticFlag`/`nonPoFlag` are pulled out of `eippSessionData.data.user`
 * today, the rest of that payload is discarded). Rather than thread the
 * whole uiConfig object through, we carry just the single boolean this
 * feature needs under the `adminUploadOnBehalf` localStorage key, written by
 * `sign-in.component.ts` / `impersonate.component.ts` alongside the other
 * per-session flags. Absent/garbage ⇒ OFF (see `canSubmitWhileImpersonated`).
 */
@Injectable({
    providedIn: "root",
})
export class ImpersonationService {
    private get store(): Pick<Storage, "getItem"> {
        return localStorage;
    }

    isImpersonated(): boolean {
        return isImpersonated(this.store);
    }

    adminUser(): string | null {
        return localStorage.getItem("adminUser");
    }

    adminEmail(): string | null {
        return localStorage.getItem("adminEmail");
    }

    private uiFlag(): boolean {
        return localStorage.getItem("adminUploadOnBehalf") === "true";
    }

    canSubmitWhileImpersonated(): boolean {
        return canSubmitWhileImpersonated(this.store, this.uiFlag());
    }
}
